import { ENV } from '@/constants';
import { formatConverterSchemaItemList } from '../formatConverterSchema';

export const schemaObject_JpegToPng = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/jpeg-to-png-converter',
			name: 'JPEG to PNG Converter — Convert JPEG to PNG Online | Lift',
			description:
				'Convert JPEG to PNG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality PNG (output) files in seconds. Try now!',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/jpeg-to-png-converter#product' },
				{ '@id': 'https://liftapp.ai/jpeg-to-png-converter#howto' },
				{ '@id': 'https://liftapp.ai/jpeg-to-png-converter#benefits' },
				{ '@id': 'https://liftapp.ai/jpeg-to-png-converter#faq' },
				{ '@id': 'https://liftapp.ai/jpeg-to-png-converter#why-lift' },
				{ '@id': 'https://liftapp.ai/jpeg-to-png-converter#format-converter' },
				{ '@id': 'https://liftapp.ai/jpeg-to-png-converter#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/jpeg-to-png-converter#product',
			name: 'JPEG to PNG Converter',
			description:
				'Convert JPEG to PNG online and transform your JPEG images into universally compatible files. Fast, secure picture converter that maintains original quality.',
			url: 'https://liftapp.ai/jpeg-to-png-converter',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp', 'image/heic'],
			memoryRequirements: 'Max file size: 20MB',
			brand: { '@type': 'Brand', name: 'Lift' },
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/jpeg-to-png-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload Your Image',
					text: 'Drag and drop an image from your device.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose an Output Format',
					text: "Select your desired output format — we'll handle the conversion automatically.",
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Download Your File',
					text: 'Get your converted image in seconds. Download a high-quality file ready to use anywhere.',
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/jpeg-to-png-converter#benefits',
			name: 'Who can benefit from JPEG to PNG Converter?',
			description:
				'Lift JPEG to PNG Converter helps anyone convert JPEG images to PNG while preserving quality.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{ '@type': 'ListItem', position: 1, name: 'No Quality Loss' },
				{ '@type': 'ListItem', position: 2, name: 'Wide Format Support' },
				{ '@type': 'ListItem', position: 3, name: 'Simple 3-Step Process' },
			],
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/jpeg-to-png-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'How does Lift JPEG to PNG converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Lift's JPEG to PNG converter uses advanced algorithms to transform your JPEG images seamlessly. Simply upload your JPEG file, and our online image converter automatically processes it into PNG format while preserving quality. Download your converted photo in seconds — no technical skills required.",
					},
				},
				{
					'@type': 'Question',
					name: 'Will the image lose quality after conversion?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "No. Lift's photo converter is designed to maintain maximum image quality during the conversion process. We use optimized compression techniques to ensure your files remain clear and sharp.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can you convert JPEG to PNG with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift supports seamless JPEG to PNG conversion along with multiple other format conversions including JPG, BMP, TIFF, and HEIC. Simply upload your JPEG file and select PNG as your desired output format.',
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe to convert files with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. Lift prioritizes your privacy and security. All image file conversions are processed securely, and we don't store or share your photos.",
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/jpeg-to-png-converter#why-lift',
			name: "Why Lift's JPEG to PNG Converter stands out",
			description:
				"Discover the advantages of Lift's image format converter: no quality loss, wide format support, simple 3-step process.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'No Quality Loss',
					description:
						'Our online photo converter preserves your image quality.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Wide Format Support',
					description:
						"Convert between JPEG, JPG, PNG, BMP, TIFF, WEBP, and HEIC. Lift's picture converter handles all major formats.",
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Simple 3-Step Process',
					description: 'Upload, convert, and download in seconds.',
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/jpeg-to-png-converter#format-converter',
			name: 'Popular Image Conversion Formats',
			description:
				'Popular image format conversion tools — WEBP, HEIC, PNG, JPEG, JPG, TIFF, BMP. Convert between formats instantly with Lift.',
			itemListOrder: 'Unordered',
			...formatConverterSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/jpeg-to-png-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'JPEG to PNG Converter',
					item: 'https://liftapp.ai/jpeg-to-png-converter',
				},
			],
		},
	],
};
